export const getFilterRuleTypeBySubject = subject => {
  switch (subject) {
    case "category":
      return "FILTER_CATEGORY";
    case "dpasubject":
      return "FILTER_FULLTEXT";
    case "geoArea":
      return "FILTER_AREA";
    default:
      return "";
  }
};

export const DPA_RESSORT = /\/category$/;
export const DPA_SUBJECT = /\/dpasubject$/;
export const GEO_AREA = /\/geoArea$/;
export const SUBJECT_ORDER = [DPA_RESSORT, DPA_SUBJECT, GEO_AREA];
